import { TypeDataPackage } from 'src/utils/constants/enum';

export enum RankByDataPackage {
  Weight = 'weight',
  Quantity = 'quantity',
  NumberBol = 'bol',
  USDValues = 'value_usd',
}

export const RankByDataPackageValue = [
  {
    value: RankByDataPackage.Weight,
    label: 'Weight',
  },
  {
    value: RankByDataPackage.Quantity,
    label: 'Quantity',
  },
  {
    value: RankByDataPackage.NumberBol,
    label: 'Number of B/L',
  },
  {
    value: RankByDataPackage.USDValues,
    label: 'USD Values',
  },
];

export const PACKAGE_NAME_LIST = [
  { value: TypeDataPackage.top_20_import_company_in_country, label: 'Top 20 Importing Companies in a Country' },
  { value: TypeDataPackage.top_20_export_company_in_country, label: 'Top 20 Exporting Companies in a Country' },
  { value: TypeDataPackage.top_20_import_product_in_country, label: 'Top 20 Most Imported Products in a Country' },
  { value: TypeDataPackage.top_20_export_product_in_country, label: 'Top 20 Most Exported Products from a Country' },
  {
    value: TypeDataPackage.top_20_trade_balance_between_2_countries,
    label: 'Top 20 Trade Balance Analysis Between 2 Country',
  },
];
